import styled from "styled-components";
import { InputContainer, InputWrapper } from "../Input/styled";

export const TimeInputContainer = styled(InputContainer)`
  max-width: 160px;
`;

export const TimeInputWrapper = styled(InputWrapper)`
  input {
    padding-right: 36px;
  }

  > svg {
    position: absolute;
    right: 15px;
    pointer-events: none;
  }
`;
